import React from 'react';
import { TargetSelect, TargetBase  } from '@code-yellow/spider';
import { observer } from 'mobx-react'
import { AdminEditModal  } from '@code-yellow/spider'
import { Company } from '../../store/Company';
import { ContactStore } from '../../store/Contact';
import { TeamStore } from '../../store/Team';
import TargetMarkdown from '../../TargetMarkdown';


export class TargetContact extends TargetBase {
    constructor(...args) {
        super(...args);
        this.toOption = this.toOption.bind(this);
    }

    store = new ContactStore();

    toOption(contact) {
        return { value: contact.id, text: contact.fullName };
    }

    toTarget(value) {
        return value && this.store.get(value);
    }

    fromTarget(value) {
        return value && value.id;
    }

    renderContent(props) {
        return (
            <TargetSelect noLabel remote
                value={this.value}
                onChange={this.onChange}
                store={this.store}
                toOption={this.toOption}
                clearable
                {...props}
            />
        )
    }
}


export class TargetTeam extends TargetBase {
    constructor(...args) {
        super(...args);
        this.toOption = this.toOption.bind(this);
    }

    store = new TeamStore();

    toOption(team) {
        return { value: team.id, text: team.name };
    }

    toTarget(value) {
        return value && this.store.get(value);
    }

    fromTarget(value) {
        return value && value.id;
    }

    renderContent(props) {
        return (
            <TargetSelect noLabel remote
                value={this.value}
                onChange={this.onChange}
                store={this.store}
                toOption={this.toOption}
                clearable
                {...props}
            />
        )
    }
}


@observer
export default class CompanyEditModal extends AdminEditModal {
    modalProps = { size: 'tiny' }

    Model = Company

    relations = [
        'responsible',
        'mainContact',
        'responsibleTeam',
    ]

    fields = [
        { type: 'text', name: 'name' },
        {
            type: 'text', name: 'shortName',
            fromTarget: (value) => value ?? '',
            toTarget: (value) => value || null,
        },
        { target: TargetContact, name: 'mainContact' },
        { target: TargetContact, name: 'responsible' },
        { target: TargetTeam, name: 'responsibleTeam' },
        { type: 'text', name: 'qaEmail' },
        { target: TargetMarkdown, name: 'communicationRhythm' },
        { target: TargetMarkdown, name: 'invoiceAgreement' },
        { target: TargetMarkdown, name: 'reportingAgreement' },
    ]
}
